<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app" style="overflow:auto">
			<reporting-sidenav></reporting-sidenav>
			<div id="content" class="app-content box-shadow-3 d-flex flex w-100">
				<div class="d-flex flex-column flex" style="overflow: auto;">
					<!-- Optional navbar at top of page -->
					<div class="navbar navbar-expand-lg flex-nowrap box-shadow">
						<!-- Page title -->
						<div class="navbar-text nav-title flex" id="pageTitle">
							Auditing
							<span class="far fa-fw fa-angle-right"></span>Scores
						</div>

						<!-- Multiselect actions -->
						<div class="btn-group" v-if="numSelected > 0">
							<div class="navbar-text nav-title no-grow mr-2" id="pageTitle">
								{{ numSelected }} Selected
							</div>
							<button class="btn white" data-toggle="dropdown" aria-expanded="false">
								<i class="fas fa-ellipsis-v faw"></i>
							</button>
							<div class="dropdown-menu dropdown-menu-right w-md">
								<a v-if="user.role.delete_data" class="dropdown-item" @click="confirmResetModal = true">
									<i class="far fa-strikethrough faw"></i>
									<label class="mb-0">Clear Scores</label>
								</a>
							</div>
						</div>
					</div>

					<!-- Page Content -->
					<div
						class="d-flex flex flex-row h100 mb-auto align-items-stretch"
						style="background-color:white; overflow: auto"
					>
						<div class="aside scroll-y">
							<div class="modal-dialog w-md light b-r b-t white p-2 audit-search">
								<div class="form-group">
									<label>Teacher</label>
									<config-user-search v-model="teacher" />
								</div>
								<div class="form-group" v-if="teacher && teacherClasses && teacherClasses.length > 0">
									<label>Class</label>
									<config-select
										:nullOption="true"
										nullText="Any"
										:options="teacherClasses"
										v-model="selectedClass"
									></config-select>
								</div>
								<div
									class="form-group invalid"
									v-if="teacher && teacherClasses && teacherClasses.length == 0"
								>
									<label>Class</label>
									<config-select :options="teacherClasses" v-model="selectedClass"></config-select>
								</div>
								<div class="form-group" v-if="!selectedClass">
									<label>Content Area</label>
									<config-select
										:nullOption="true"
										nullText="Any"
										:options="contentAreas"
										v-model="selectedCA"
									></config-select>
								</div>
								<div class="form-group" v-if="!selectedClass">
									<label>Grade</label>
									<config-select
										:nullOption="true"
										nullText="Any"
										sortBy="sequence"
										:options="grades"
										v-model="selectedGrade"
									></config-select>
								</div>
								<div class="form-group" :class="{ invalid: !loading && !selectedAsmt }">
									<label>Assessment</label>
									<config-select
										:options="filteredAssessments"
										v-model="selectedAsmt"
									></config-select>
								</div>
								<div class="form-group">
									<label>Student</label>
									<config-student-search v-model="student" />
								</div>
								<div class="form-group">
									<label>Scored By</label>
									<config-user-search v-model="users" includeTeams multiple />
								</div>
								<div class="form-group">
									<label>Score Type</label>
									<v-select multiple :options="score_types" v-model="filter_types"></v-select>
								</div>

								<div class="form-group">
									<label>
										From Date
										<user-timezone />
									</label>
									<config-date
										v-model="fromDate"
										:config="{ showClear: true }"
										class="dtp-scrollfix dtp-scrollfix-date"
									></config-date>
								</div>
								<div class="form-group">
									<label>
										To Date
										<user-timezone />
									</label>
									<config-date
										v-model="toDate"
										:config="{ showClear: true }"
										defaultTime="11:59 PM"
										class="dtp-scrollfix dtp-scrollfix-time"
									></config-date>
								</div>

								<div class="btn-group mt-2 btn-block w-100">
									<button @click="showQueryModal()" class="btn btn-block theme">Query Scores</button>
									<button
										@click="clearScoreSearch()"
										class="btn theme lighten-2"
										v-tippy
										title="Clear"
									>
										<i class="far fa-times"></i>
									</button>
								</div>
								<table class="table condensed-table" v-if="ats_display && ats_display.length > 0">
									<tr>
										<th>Trait</th>
										<th>Score</th>
									</tr>
									<tr v-for="(row, i) in ats_display" :key="i">
										<td>{{ row.name }}</td>
										<td>{{ row.score }}</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="flex d-flex flex-column" style="overflow: hidden;">
							<div class="flex scroll-y scroll-x">
								<!-- Page content goes here -->
								<b-table
									ref="table"
									hover
									:show-empty="true"
									:items="provider"
									:fields="fields"
									:current-page="currentPage"
									:per-page="perPage"
									:filter="filter"
									:sort-by.sync="sortBy"
									:sort-desc.sync="sortDesc"
								>
									<!-- Select -->
									<template slot="HEAD_select" slot-scope="data">
										<table-multiselect
											v-model="multiSelect"
											:selectAll.sync="selectAll"
											master
											:items="currentItems"
											byField="score_id"
											:totalRows="totalRows"
											:numSelected.sync="numSelected"
											:query="query"
											:reset="resetSelection"
										></table-multiselect>
									</template>
									<template slot="select" slot-scope="data">
										<table-multiselect
											:value="multiSelect"
											:selectAll="selectAll"
											:id="data.item.score_id"
										></table-multiselect>
									</template>

									<!-- Student -->
									<template slot="student_ln" slot-scope="data">
										<div
											v-tippy="{ theme: 'popover', placement: 'bottom' }"
											:title="auditDetailsTooltip(data.item)"
										>
											<div v-if="data.item.reliability_score" class="dot"></div>
											<div v-if="!data.item.reliability_score" class="nodot"></div>
											<span>{{ data.item.student_ln }}, {{ data.item.student_fn }}</span>
											<span class="text-xxs text-muted">({{ data.item.student_ref_id }})</span>
										</div>
									</template>

									<template slot="score_type" slot-scope="data">
										<span
											v-tippy
											:title="getScoreTypeName(data.item.score_type)"
											class="d-inline-flex flex-row align-items-center"
										>
											<i class="material-icons tiny mr-1">{{
												getScoreTypeIcon(data.item.score_type)
											}}</i>
											<span>{{ getScoreTypeAbr(data.item.score_type) }}</span>
										</span>
									</template>

									<template slot="first_name" slot-scope="data">
										<span>{{ data.item.user.first_name }} {{ data.item.user.last_name }}</span>
										<span class="text-xxs text-muted">({{ data.item.user.scorer_id }})</span>
									</template>

									<!-- State -->
									<template slot="state" slot-scope="data">{{ getState(data.item.state) }}</template>

									<!-- Scores -->
									<template slot="score" slot-scope="data">
										<inline-score
											:score="data.item"
											:rubric="selectedItem && selectedItem.rubric"
											tooltip
										/>
									</template>

									<!-- Think time -->
									<template slot="think_time" slot-scope="data">{{
										getTime(data.item.think_time)
									}}</template>

									<!-- Created At -->
									<template slot="applied_at" slot-scope="data">{{
										format(data.item.applied_at)
									}}</template>
									<!-- Edit -->
									<template slot="actions" slot-scope="data">
										<div class="d-flex flex-rows">
											<div class="w30">
												<a
													:href="
														`#/audit/${selectedAsmt.id}/${selectedItem.id}/${data.item.id}`
													"
													class="btn btn-sm btn-icon btn-rounded theme-accent text-white m-0"
													v-tippy
													title="View"
												>
													<i class="far fa-search"></i>
												</a>
											</div>
										</div>
									</template>
								</b-table>
							</div>
							<div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
								<a class="flex mx-3"
									>Page {{ totalRows > 0 ? currentPage : 0 }} of
									{{ Math.ceil(totalRows / perPage) }} ({{ totalRows }})</a
								>
								<div>
									<b-pagination
										size="md"
										class="m-1"
										:total-rows="totalRows"
										v-model="currentPage"
										:per-page="perPage"
									></b-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- TraitScore query modal -->
		<b-modal
			id="traitScoreModal"
			v-model="queryModal"
			v-if="selectedItem && selectedItem.rubric"
			no-fade
			@hide="hideQueryModal"
		>
			<template slot="modal-title">Score Query</template>
			<div class="row">
				<table class="table ats-table">
					<thead v-if="score_specific_query">
						<tr>
							<th style="width: 50%"></th>
							<th></th>
							<th class="text-center">
								<span class="d-flex flex-row align-items-center">
									<i class="material-icons mi-small mr-1">{{ fs.scoreTypeIcon(1) }}</i>
									{{ fs.scoreTypeAbr(1) }}
								</span>
							</th>
							<th class="text-center">
								<span class="d-flex flex-row align-items-center">
									<i class="material-icons mi-small mr-1">{{ fs.scoreTypeIcon(2) }}</i>
									{{ fs.scoreTypeAbr(2) }}
								</span>
							</th>
							<th class="text-center">
								<span class="d-flex flex-row align-items-center">
									<i class="material-icons mi-small mr-1">{{ fs.scoreTypeIcon(3) }}</i>
									{{ fs.scoreTypeAbr(3) }}
								</span>
							</th>
							<th class="text-center">
								<span class="d-flex flex-row align-items-center">
									<i class="material-icons mi-small mr-1">{{ fs.scoreTypeIcon(4) }}</i>
									{{ fs.scoreTypeAbr(4) }}
								</span>
							</th>
							<th style="width: 50%"></th>
						</tr>
					</thead>
					<thead v-if="!score_specific_query">
						<tr>
							<th style="width: 50%"></th>
							<th></th>
							<th class="text-center">Score</th>
							<th style="width: 50%"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="trait in selectedItem.rubric.traits" :key="trait.id">
							<td></td>
							<td class="p-custom pr-4 v-mid">{{ trait.name }}</td>
							<td v-if="!score_specific_query" style="width:10px;">
								<v-select
									:onChange="tsChange(trait.id, 0)"
									class="v-select-narrow"
									:options="traitSelectionMap[trait.id][0].sps"
									v-model="traitSelectionMap[trait.id][0].selected"
									:searchable="false"
									:clearable="false"
								></v-select>
							</td>
							<td v-if="score_specific_query" v-for="st in score_types" :key="st.type">
								<v-select
									:onChange="tsChange(trait.id, st.type)"
									class="v-select-narrow"
									:options="traitSelectionMap[trait.id][st.type].sps"
									:searchable="false"
									:clearable="false"
									v-model="traitSelectionMap[trait.id][st.type].selected"
								></v-select>
							</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
			<template slot="modal-footer">
				<button @click="applyQueryModal" class="btn btn-flat primary">Apply</button>
			</template>
		</b-modal>

		<b-modal id="confirmReset" v-model="confirmResetModal">
			<template slot="modal-title">Reset Scores</template>
			<h6>Do you really want to reset {{ numSelected }} scores?</h6>
			<h6>
				<span class="text-danger far faw fa-exclamation-triangle"></span>
				The reset operation will run immediately, and cannot be canceled or reversed!
			</h6>
			<template slot="modal-footer">
				<button class="btn btn-flat btn-primary" @click="confirmResetModal = false">Cancel</button>
				<button @click="resetScores" class="btn btn-flat btn-danger">Reset</button>
			</template>
		</b-modal>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w30 {
	width: 30px;
}
.audit-search > .form-group {
	margin-bottom: 5px;
}
.badge {
	width: 1.25rem;
	height: 1.5rem;
	line-height: 1.4rem;
	padding: 0 0;
}
.wide-badge {
	font-size: 1rem;
	width: initial !important;
}
.empty-badge {
	box-shadow: inset 0px 0px 0px 1.2px rgba(0, 0, 0, 0.2);
	background-color: white;
}
.small {
	font-size: 1.25rem;
}
.tiny {
	font-size: 1rem;
}
.ats-table {
	white-space: nowrap;
}
label {
	margin-top: 0.25rem;
	margin-bottom: 0.25rem;
}
.invalid {
	color: red;
}
.invalid > div {
	border: 1px solid red;
}
</style>

<script>
//UI Components
//Libraries
//import _ from "lodash";
import moment from "moment";
import $ from "jquery";

//Services
import ConfigService from "@/services/ConfigService";
import AuditingService from "@/services/AuditingService";
import ScoringService from "@/services/ScoringService";
import ClassService from "@/services/ClassService";
import fs from "@/services/FormatService";
import notie from "@/services/NotieService";
import store from "@/services/Store";
import BB from "bluebird";

import TableMultiselect from "@/components/TableMultiselect";
import ConfigUserSearch from "@/components/ConfigUserSearch";
import ConfigStudentSearch from "@/components/ConfigStudentSearch";
import ConfigSelect from "@/components/ConfigSelect";
import ConfigDate from "@/components/ConfigDate";
import InlineScore from "@/components/InlineScore";
import UserTimezone from "@/components/UserTimezone";

export default {
	name: "ScoreAuditing",
	components: {
		InlineScore,
		TableMultiselect,
		ConfigUserSearch,
		ConfigStudentSearch,
		ConfigSelect,
		ConfigDate,
		UserTimezone
	},
	data() {
		var scoreTypes = [
			{ label: fs.scoreTypeAbr(1), type: 1 },
			{ label: fs.scoreTypeAbr(2), type: 2 },
			{ label: fs.scoreTypeAbr(3), type: 3 }
		];

		var filter_types = store.resolveSelectedScoreTypes(this, scoreTypes, "audit.s.filter_types");
		var response_id = store.get(this, "audit.s.response_id");
		var users = store.getDefault(this, "audit.s.users", []);
		var teacher = store.getDefault(this, "audit.s.teacher", null);
		var selectedClass = store.getDefault(this, "audit.s.selectedClass", null);
		var student = store.getDefault(this, "audit.s.student", null);
		var score_specific_query = store.get(this, "audit.s.score_specific_query");
		var sortBy = store.get(this, "audit.s.sortBy");
		var sortDesc = store.get(this, "audit.s.sortDesc");
		var currentPage = store.get(this, "audit.s.currentPage");
		// debugger;

		//Dynamically bound fields
		return {
			fs: fs,
			user: this.$route.meta.user,
			loading: true,
			currentPage: currentPage,
			perPage: 20,
			totalRows: 0,
			filter: "",
			sortBy: sortBy,
			sortDesc: sortDesc,
			currentItems: [],
			query: null,
			multiSelect: [],
			selectAll: null,
			numSelected: 0,
			queueResetSelection: false,

			teacherClasses: null,
			selectedClass: null,

			contentAreas: [],
			selectedCA: null,

			grades: [],
			selectedGrade: null,

			assessments: [],
			selectedAsmt: null,
			selectedItem: null,

			fromDate: store.get(this, "audit.s.fromDate"),
			toDate: store.get(this, "audit.s.toDate"),

			response_id: response_id ? response_id : "",
			users: users,
			teacher: teacher,
			student: student,

			selected_resp: null,

			//Score Query
			score_types: scoreTypes,
			filter_types: filter_types,
			score_specific_query: score_specific_query,
			traitSelectionMap: null,
			audit_trait_scores: [],
			ats_display: null,

			applyATS: null,
			oldScoreQuery: null,
			queryModal: false,
			confirmResetModal: false
		};
	},

	created() {
		this.loadConfigData();
		this.refreshTable = _.debounce(() => {
			this.$refs.table.refresh();
		}, 500);
		this.loadTeacherClasses();
	},

	watch: {
		teacher() {
			this.loadTeacherClasses();
			store.set(this, "audit.s.teacher", this.teacher);
		},
		selectedClass() {
			this.refreshTable();
			store.set(this, "audit.s.selectedClass", this.selectedClass);
		},
		selectedState() {
			this.refreshTable();
			store.set(this, "audit.s.selectedState", this.selectedState);
		},
		selectedCA() {
			if (this.selectedCA && this.selectedAsmt && this.selectedAsmt.content_area_id != this.selectedCA.id) {
				this.selectedAsmt = null;
			}

			store.set(this, "audit.s.selectedCA", this.selectedAsmt);
		},
		selectedGrade() {
			if (this.selectedGrade && this.selectedAsmt) {
				let found = false;
				_.each(this.selectedAsmt.grade_ids, gid => {
					if (this.selectedGrade.id == gid) {
						found = true;
					}
				});
				if (!found) {
					this.selectedAsmt = null;
				}
			}

			store.set(this, "audit.s.selectedGrade", this.selectedAsmt);
		},
		selectedAsmt() {
			this.refreshTable();
			store.set(this, "audit.s.selectedAsmt", this.selectedAsmt);
		},
		selectedItem(newVal, oldVal) {
			if (!this.selectedItem) {
				return;
			}
			this.setupTraitScoreSelections();
			if (!oldVal) {
				this.audit_trait_scores = store.resolveAuditingTraitScores(
					this,
					this.selectedItem,
					"audit.s.trait_scores"
				);
				this.refreshTable();
			}
		},
		response_id() {
			this.refreshTable();
			store.set(this, "audit.s.response_id", this.response_id);
		},
		student() {
			this.refreshTable();
			store.set(this, "audit.s.student", this.student);
		},
		users() {
			this.refreshTable();
			store.set(this, "audit.s.users", this.users);
		},
		filter_types() {
			this.refreshTable();
			store.set(this, "audit.s.filter_types", this.filter_types);
		},
		score_specific_query() {
			this.audit_trait_scores = [];
			store.set(this, "audit.s.score_specific_query", this.score_specific_query);
		},
		audit_trait_scores() {
			store.set(this, "audit.s.scores.trait_scores", this.audit_trait_scores);
			this.updateATSDisplay();
		},
		fromDate() {
			this.refreshTable();
			store.set(this, "audit.s.fromDate", this.fromDate);
		},
		toDate() {
			this.refreshTable();
			store.set(this, "audit.s.toDate", this.toDate);
		}
	},

	computed: {
		filteredAssessments() {
			if (this.selectedClass) {
				//Filter by class
				return _.filter(this.assessments, asmt => {
					let inClass = false;
					_.each(this.selectedClass.deliveries, del => {
						if (del.assessment_id == asmt.id) {
							inClass = true;
						}
					});
					return inClass;
				});
			} else if (this.selectedCA && this.selectedGrade) {
				//Filter by CA && grade
				return _.filter(this.assessments, asmt => {
					let matchedCA = true;
					if (this.selectedCA) {
						let secondCA = false
						if(asmt.secondary_content_area_id){
							secondCA = asmt.secondary_content_area_id.includes(this.selectedCA.id);
						}
						matchedCA = this.selectedCA.id == asmt.content_area_id || secondCA;
					}
					let matchedGrade = true;
					if (this.selectedGrade) {
						matchedGrade = false;
						_.each(asmt.grade_ids, gid => {
							if (this.selectedGrade.id == gid) {
								matchedGrade = true;
							}
						});
					}

					return matchedCA && matchedGrade;
				});
			} else {
				//No filter
				return this.assessments;
			}
		},

		fields() {
			let fields = [];
			if (this.user.role.delete_data) {
				fields = fields.concat([
					{
						key: "select",
						thClass: "p-custom p-0 v-mid",
						thStyle: "width: 40px;",
						tdClass: "p-custom p-0 v-mid"
					}
				]);
			}
			fields = fields.concat([
				{ key: "student_ln", label: "Student", sortable: true },
				{
					key: "first_name",
					label: "Scorer",
					sortable: true
				},
				{
					key: "score_type",
					label: "Type",
					tdClass: "p-custom py-0 v-mid",
					sortable: true
				},
				{
					key: "score",
					tdClass: "p-custom py-0 v-mid",
					sortable: false
				},
				{
					key: "think_time",
					label: "Time",
					sortable: true
				},
				{
					key: "applied_at",
					tdClass: "text-truncate",
					sortable: true
				},
				{ key: "actions", tdClass: "p-custom py-0 v-mid" }
			]);

			return fields;
		}
	},

	methods: {
		loadConfigData() {
			BB.props({
				contentAreas: ConfigService.listContentAreas(),
				grades: ConfigService.listGrades(),
				assessments: ConfigService.listAssessments()
			}).then(resps => {
				this.contentAreas = resps.contentAreas.data.content_areas;
				this.selectedCA = store.resolveFromList(this, this.contentAreas, "id", null, "audit.s.selectedCA");

				this.grades = resps.grades.data;
				this.selectedGrade = store.resolveFromList(this, this.grades, "id", null, "audit.s.selectedGrade");

				this.assessments = resps.assessments.data.assessments;
				this.selectedAsmt = store.resolveFromList(this, this.assessments, "id", null, "audit.s.selectedAsmt");

				this.loading = false;
				this.refreshTable();
			});
		},

		getQuery() {
			let user_ids = [];
			_.each(this.users, u => {
				if (u.users) {
					_.each(u.users, tu => {
						user_ids.push(tu.id);
					});
				} else {
					user_ids.push(u.id);
				}
			});

			let query = {
				client_id: this.user.client.id,
				teacher_id: this.teacher && this.teacher.id,
				class_id: this.selectedClass && this.selectedClass.id,
				asmt_id: this.selectedAsmt && this.selectedAsmt.id,
				response_id: this.response_id,
				student_id: this.student && this.student.id,
				user_ids: user_ids,
				trait_scores: this.audit_trait_scores,
				score_types: _.map(this.filter_types, t => {
					return t.type;
				}),
				start_date: this.fromDate,
				end_date: this.toDate
			};

			return query;
		},

		provider(ctx) {
			store.set(this, "audit.s.sortBy", this.sortBy);
			store.set(this, "audit.s.sortDesc", this.sortDesc);
			store.set(this, "audit.s.currentPage", this.currentPage);
			if (this.loading) {
				return [];
			}

			let query = this.getQuery();
			return BB.props({
				audit: AuditingService.scoreAuditQuery(query, ctx),
				item: ConfigService.getItem(this.selectedAsmt.id)
			})
				.then(resps => {
					if (this.queueResetSelection) {
						this.resetSelection();
						this.queueResetSelection = false;
					}

					this.query = query;
					this.totalRows = resps.audit.data.totalRows;
					this.currentItems = resps.audit.data.rows;
					this.smartStripe(this.currentItems);

					this.selectedItem = resps.item.data;

					return this.currentItems;
				})
				.catch(err => {
					return [];
				});
		},

		loadTeacherClasses() {
			if (this.teacher) {
				ClassService.getTeacherClasses(this.teacher.id).then(resp => {
					this.teacherClasses = resp.data.classes;
				});
			} else {
				this.teacherClasses = [];
			}
			this.refreshTable();
		},

		resetScores() {
			let selection = {
				selected_ids: this.multiSelect,
				select_all: this.selectAll,
				query: this.getQuery()
			};
			AuditingService.resetScores(selection)
				.then(resp => {
					notie.success("Scores cleared!");
					this.refreshAndResetSelection();
				})
				.catch(err => {
					notie.error("Failed to clear scores", err);
				});
		},

		smartStripe(responses) {
			var lastRef = "";
			var variant = "nostripe";
			_.each(responses, r => {
				if (r.ref_id != lastRef) {
					variant = variant == "nostripe" ? "stripe" : "nostripe";
				}
				lastRef = r.ref_id;
				r._rowVariant = variant;
			});
		},

		getTime(time) {
			if (time == 0) {
				return "——";
			} else if (!time) {
				return "——";
			} else if (time < 3600) {
				return moment()
					.startOf("day")
					.seconds(time)
					.format("mm:ss");
			} else {
				return moment()
					.startOf("day")
					.seconds(time)
					.format("HH:mm:ss");
			}
		},

		getScoreTypeIcon(type) {
			switch (type) {
				case 1:
					return "done";
				case 2:
					return "done";
				case 3:
					return "done_all";
				case 4:
					return "verified_user";
			}
		},

		getScoreTypeName(type) {
			switch (type) {
				case 1:
					return "First";
				case 2:
					return "Second";
				case 3:
					return "Resolution";
				case 4:
					return "Backread";
			}
		},

		getScoreTypeAbr(type) {
			switch (type) {
				case 1:
					return "1st";
				case 2:
					return "2nd";
				case 3:
					return "Res";
				case 4:
					return "BR";
			}
		},

		format(date) {
			return moment(date).format("MM/DD/YY h:mm:ss a");
		},

		tsChange(trait_id, score_type) {
			return r => {
				//Remove all entries for this trait_id and score_type
				_.remove(this.audit_trait_scores, e => {
					return e.trait_id == trait_id && e.score_type == score_type;
				});

				if (r) {
					this.audit_trait_scores.push({
						trait_id: trait_id,
						score_type: score_type,
						score: r.value
					});
				}
			};
		},

		setupTraitScoreSelections() {
			//For each trait, and each score type, we need to create selection lists
			this.traitSelectionMap = null;
			var traitSelectionMap = {};
			var _this = this;
			_.each(this.selectedItem.rubric.traits, t => {
				var scoreTypeMap = {};
				var sps = [];
				for (var i = t.min; i < t.max + 1; i++) {
					sps.push({
						trait_id: t.id,
						label: "" + i,
						value: i
					});
				}

				let selectedATS = _.find(this.audit_trait_scores, {
					trait_id: t.id,
					score_type: 0
				});
				let selectedSP = selectedATS ? _.find(sps, { value: selectedATS.score }) : null;
				scoreTypeMap[0] = { selected: null, sps: sps };
				_.each(_this.score_types, st => {
					let selectedATS = _.find(this.audit_trait_scores, {
						trait_id: t.id,
						score_type: 0
					});
					let selectedSP = selectedATS ? _.find(sps, { value: selectedATS.score }) : null;
					scoreTypeMap[st.type] = { selected: null, sps: sps };
				});

				_.each(scoreTypeMap, st => {
					_.each(st.sps, sp => {
						sp.st = st.type;
					});
				});

				traitSelectionMap[t.id] = scoreTypeMap;
			});
			this.traitSelectionMap = traitSelectionMap;
		},

		clearScoreSearch() {
			this.audit_trait_scores = [];
			this.score_specific_query = true;
			this.score_specific_query = false;
			this.traitSelectionMap = null;
			this.setupTraitScoreSelections();
			this.$forceUpdate();
			this.refreshTable();
		},

		updateATSDisplay() {
			let rows = [];
			let scoreTypeNumMap = {};
			_.each(this.audit_trait_scores, ats => {
				var trait = _.find(this.selectedItem.rubric.traits, {
					id: ats.trait_id
				});
				if (trait) {
					scoreTypeNumMap[ats.score_type] = scoreTypeNumMap[ats.score_type] || 0;
					scoreTypeNumMap[ats.score_type]++;
					rows.push({
						name: trait.name,
						score_type: ats.score_type,
						score: ats.score
					});
				}
			});

			rows = _.orderBy(rows, ["score_type", "name"]);
			let currentScoreType = -1;
			_.each(rows, row => {
				if (currentScoreType != row.score_type) {
					row.first_of_type = true;
					row.rowspan = scoreTypeNumMap[row.score_type] || 1;
					currentScoreType = row.score_type;
				}
			});

			this.ats_display = rows;
		},

		//Scoring stuff
		canScore(resp) {
			return ScoringService.canScore(resp);
		},

		showAlreadyScoredModal(resp) {
			$("#alreadyScoredWarning").modal("show");
		},

		unlock(resp) {
			ScoringService.unlockResponse(resp)
				.then(() => {
					notie.info("Response unlocked");
					this.refreshTable();
				})
				.catch(e => {
					notie.error("Failed to unlock response");
					this.refreshTable();
				});
		},

		resetSelection() {
			this.multiSelect = [];
			this.selectAll = false;
		},

		refreshAndResetSelection() {
			this.queueResetSelection = true;
			this.refreshTable();
		},

		groupResponses() {
			return this.sortBy == "" || this.sortBy == "ref_id";
		},

		showQueryModal() {
			//this.oldScoreQuery = _.cloneDeep(this.audit_trait_scores);
			this.applyATS = false;
			this.updateTraitScoreMap();
			this.queryModal = true;
		},

		updateTraitScoreMap() {
			_.each(this.traitSelectionMap, trait => {
				_.each(trait, opt => {
					opt.selected = null;
				});
			});

			_.each(this.audit_trait_scores, ats => {
				let trait = this.traitSelectionMap[ats.trait_id];
				if (trait) {
					let opt = trait[ats.score_type];
					if (opt) {
						let choice = _.find(opt.sps, { value: ats.score });
						if (choice) {
							opt.selected = choice;
						}
					}
				}
			});

			this.$forceUpdate();
		},

		hideQueryModal() {
			if (!this.applyATS) {
				this.audit_trait_scores = _.cloneDeep(this.oldScoreQuery);
			} else {
				this.applyATS = false;
			}
		},

		getState(state) {
			// console.log(state);
			var stateObj = _.find(this.states, { value: state });
			if (stateObj) {
				return stateObj.label;
			}
			return "?";
		},

		applyQueryModal() {
			this.applyATS = true;
			this.queryModal = false;
			this.refreshTable();
		},

		auditDetailsTooltip(row) {
			let tooltip = `
			<table class="my-2">
				<tr>
					<td class="px-2 py-1 _600">${row.teacher_names.length == 1 ? "Teacher" : "Teachers"}:</td>
					<td class="px-2 py-1">${row.teacher_names.join(", ")}</td>
				</tr>
				<tr class="b-t">
					<td class="px-2 py-1 _600">Class:</td>
					<td class="px-2 py-1">${row.class_name}</td>
				</tr>
				<tr class="b-t">
					<td class="px-2 py-1 _600">Administration:</td>
					<td class="px-2 py-1">${row.delivery_name}</div>
				</tr>
			</table>
			`;

			return tooltip;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/QualityMgmt/ScoreAuditing.vue